import React from "react";
import useSPPosition from "../../hooks/useSPPosition";
import SPPositionFormGroup from "./SPPositionFormGroup";
import useSPUndo from "../../hooks/useSPUndo";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";
import SearchField from "../SearchField/SearchField";

const PositionsSPStorage = ({ clearfield }) => {
  // Load context values
  const { SPposition, setSPposition, setSPpositionData } = useSPPosition();
  const { positionEditsSP, editIDSP, setEditIDSP, undoListSP } = useSPUndo();

  return (
    <fieldset>
      <legend>Storage Details:</legend>
      <div className='form-group'>
        <label>Warehouse:</label>
        <SearchField
          required={true}
          searchURL='/api/positions/getUSwarehouses'
          value={SPposition.warehouse || ""}
          valueName='warehouse'
          valueID='warehouseID'
          customplaceholder='warehouse...'
          onItemSelect={(item) => {
            handleInputSelect(
              item,
              positionEditsSP,
              editIDSP,
              setEditIDSP,
              setSPposition,
              setSPpositionData,
              addEdits,
              undoListSP,
              "warehouse",
              "warehouse"
            );
          }}
          style={{ textAlign: "left" }}
          clearfield={clearfield}
        />
      </div>
      <SPPositionFormGroup
        type={"date"}
        labelname={"Entry Date"}
        inputname={"whentrydate"}
        inputtype={"text"}
        style={{ textAlign: "left" }}
      />
      <SPPositionFormGroup labelname={"Fixed Cost"} inputname={"whfixedcost"} inputtype={"currency"} />
      <SPPositionFormGroup labelname={"Variable Cost ($/pallet)"} inputname={"whvarcost"} inputtype={"currency"} />
      <SPPositionFormGroup labelname={"Grace Period (days)"} inputname={"whgraceperiod"} inputtype={"integer"} />
      <SPPositionFormGroup labelname={"Accrual Period (days)"} inputname={"whaccrualperiod"} inputtype={"integer"} />
    </fieldset>
  );
};

export default PositionsSPStorage;
